
































































import { listFactory } from '@/main/pages';
import { showAlert } from '@/main/utils/notifications';
import { Partner } from '@/modules/kartoteka/partner';
import { infoButton } from '@/main/utils/tableOperations';
import _ from 'lodash';

import { apiProvider } from './api';


import { NAME, ACCOUNT_UNSETTLEMENT_VALUE, ACCOUNT_SETTLEMENT_VALUE } from '../constants';
import { PlatbaTyp } from '../../servis/zakazka/constants';
import { store } from './store/list';

import { listMutations } from './store/types';
import Dialog from '@/main/components/dms/layout/Dialog.vue';

export default listFactory(NAME, store).extend({
	components: {
		PartnerSelect: Partner.components.Select,
	},
	data() {
		return {
			infoButton,
			showDialog: false,
			remarks: '',
			amountSettlementValue: 0,
			amountUnsettlementValue: 0,
			isSettlement: false,
			isReverseSettlement: false,
			selectedPaymentMethod: null as number | null,
			ReqObj: {
				CustomerId: null as number | null,
				CustomerName: null as string | null,
				EguiDate: null as Date | null,
				EguiNo: null as string | null,
				InvoiceNo: null as string | null,
				InvoiceAmount: null as number | null,
				ARAmount: null as number | null,
				OrderNo: null as number | null,
				PaymentMethod: null as number | null,
				InvoiceDate: null as Date | null,
				InvoiceId: null as number | null,
				Remark: null as string | null,
				SettlementNo: null as string | null,
				WorkshopId: null as number | null,
			},
		};
	},
	computed: {
		mutationsMappers() {
			return {
				zakaznik: `${this.storeUri}/${listMutations.ACOOUNTING_ZAKAZNIK_FILTER_SELECT_MAPPER}`,
			};
		},
		extraButtons(): any {
			return {
				...infoButton((event: any, cells: any) => {
					if (cells[this.table.cellNames!.SETTLEMENT_STATUS] === ACCOUNT_UNSETTLEMENT_VALUE) {
						this.isReverseSettlement = true;
						this.isSettlement = false;
						this.selectedPaymentMethod = PlatbaTyp.CASH;
					} else {
						const paymentMethodId: any = this.dropdownList.PaymentMethod.find((item: any) => item.Text === cells[this.table.cellNames!.PAYMENT_METHOD]);
						this.selectedPaymentMethod = paymentMethodId?.Value;
						this.isReverseSettlement = false;
						this.isSettlement = true;
					}
					this.remarks = '';
					this.showDialog = true;
					this.ReqObj = {
						CustomerId: cells[this.table.cellNames!.CUSTOMER_ID],
						CustomerName: cells[this.table.cellNames!.CUSTOMER_NAME],
						EguiDate: cells[this.table.cellNames!.EGUI_DATE],
						EguiNo: cells[this.table.cellNames!.EGUI_NO],
						InvoiceNo: cells[this.table.cellNames!.INVOICE_NO],
						InvoiceAmount: cells[this.table.cellNames!.INVOICE_AMOUNT],
						ARAmount: cells[this.table.cellNames!.AR_AMOUNT],
						OrderNo: cells[this.table.cellNames!.ORDER_NO],
						PaymentMethod: this.PaymentMethod,
						InvoiceDate: cells[this.table.cellNames!.INVOICE_DATE],
						InvoiceId: cells[this.table.cellNames!.INVOICE_ID],
						Remark: this.remarks,
						SettlementNo: cells[this.table.cellNames!.SETTLEMENT_NO],
						WorkshopId: this.filter.WorkshopId,
					};
				}),
			};
		},
	},
	methods: {
		async searchData() {
			try {
				this.filter.CustomerId = this.localState.CustomerId;
				if (_.isNil(this.filter.CustomerId) || _.isNil(this.filter.WorkshopId) || _.isNil(this.filter.FromDate) || _.isNil(this.filter.ToDate)) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('Invalid_Form') });
					return;
				}
				this.startLoading();
				const Totaldata = await this.tableData();
				this.amountSettlementValue = await this.calculateAmount(ACCOUNT_SETTLEMENT_VALUE, Totaldata);
				this.amountUnsettlementValue = await this.calculateAmount(ACCOUNT_UNSETTLEMENT_VALUE, Totaldata);
			} catch (error) {
				showAlert({
					message: this.LocalizeChyboveHlasky('LocalMsg'),
					title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
					options: {
						type: 'error',
					},
				});
			} finally {
				this.endLoading();
			}
		},
		ARFilterdateValidation() {
			if (this.FromDate && this.ToDate) {
				const fromDate = new Date(this.FromDate);
				const toDate = new Date(this.ToDate);

				if (fromDate > toDate) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('GREATER_DATE_VALIDATION'),
						options: { type: 'error' },
						localizeMessage: false,
					});
					this.ToDate = null;
					return false;
				}
				return true;
			}
			return false;
		},

		async calculateAmount(statusId: string, totalData: any) {
			const AccountReceivableAmountIndex: number = this.table.cellNames!.AR_AMOUNT;
			const statusIdIndex: number = this.table.cellNames!.SETTLEMENT_STATUS;
			const amountSettleValue = _.reduce(totalData.data, (sum: number, item: any) => {
				if (item.Cells[statusIdIndex] === statusId) {
					const value = item.Cells[AccountReceivableAmountIndex];
					if (!_.isNil(value)) {
						const parsedValue = parseInt(value, 10);
						// eslint-disable-next-line no-restricted-globals
						return sum + (isNaN(parsedValue) ? 0 : parsedValue);
					}
					return sum;
				}
				return sum;
			}, 0);
			return amountSettleValue;
		},

		async settleTransaction() {
			if (!this.validateRemark()) {
				this.isReverseSettlement = true;
				return;
			}
			this.ReqObj.PaymentMethod = this.selectedPaymentMethod;
			this.ReqObj.Remark = this.remarks;
			this.startLoading();
			this.isSettlement = true;
			this.isReverseSettlement = true;
			await apiProvider.settle(this.ReqObj);
			this.showDialog = false;
			this.searchData();
			this.endLoading();
		},

		async reverseSettlement() {
			if (!this.validateRemark()) {
				this.isSettlement = true;
				return;
			}
			this.ReqObj.PaymentMethod = this.selectedPaymentMethod;
			this.ReqObj.Remark = this.remarks;
			this.startLoading();
			this.isSettlement = true;
			this.isReverseSettlement = true;
			await apiProvider.reverse(this.ReqObj);
			this.showDialog = false;
			this.searchData();
			this.endLoading();
		},
		validateRemark() {
			if (_.isEmpty(this.remarks.trim())) {
				this.showErrorAlert({
					message: this.LocalizeChyboveHlasky('Invalid_Form'),
					options: { type: 'error' },
					localizeMessage: false,
					title: 'Notification',
				});
				return false;
			}
			return true;
		},
	},
});
